export enum PersonsType {
    Adult = "adult",
    Child = "child",
    Family = "family",
    Unknown = "unknown",
}
